const MODELO_SQL = `
{
  "user": "",
  "password": "",
  "server": "",
  "database": ""
}
`

const MODELO_ORACLE = `
{
  "user": "",
  "password": "",
  "connectString": "endereco_url:numero_porta/prd_sml:DEDICATED",
  "poolIncrement": 0,
  "poolMax": 8,
  "poolMin": 8
}
`

const MODELO_FIREBIRD = `
{
  "host": "",
  "port": numero,
  "database": "",
  "user": "sysdba",
  "password": "masterkey",
  "retryConnectionInterval": 10000,
  "encoding": "UTF8"
}
`

const MODELO_MYSQL = `
{
  "user": "",
  "password": "",
  "database": "",
  "host": "",
  "decimalNumbers": true,
  "port": 3306,
  "timezone": "-03:00",
  "charset" : "utf8",
  "pool": {
    "max": 5,
    "min": 0,
    "acquire": 90000,
    "idle": 10000
  }
}
`

// Tipos de Conexao
export interface TipoConexaoInterface {
  idTipoConexao: string
  descricao: string
  modeloConexao: string
}

export enum TipoConexaoType {
  SEM_CONEXAO = '',
  SQLSERVER = 'SQLSERVER',
  ORACLE = 'ORACLE',
  FIREBIRD = 'FIREBIRD',
  MYSQL = 'MYSQL'
}

export const TipoConexaoTypes: Array<TipoConexaoInterface> = [
  { idTipoConexao: TipoConexaoType.SQLSERVER, descricao: 'SQL Server', modeloConexao: MODELO_SQL },
  { idTipoConexao: TipoConexaoType.ORACLE, descricao: 'Oracle', modeloConexao: MODELO_ORACLE },
  { idTipoConexao: TipoConexaoType.FIREBIRD, descricao: 'Firebird', modeloConexao: MODELO_FIREBIRD },
  { idTipoConexao: TipoConexaoType.MYSQL, descricao: 'MySQL', modeloConexao: MODELO_MYSQL }
]

// Tipo de Sistema de ERP
export interface TipoERPInterface {
  idTipoERP: string
  descricao: string
  idTipoConexao: string
}

export enum TipoERPType {
  SEM_ACESSO = 'Sem Acesso',
  MV = 'MV',
  SPData = 'SPData'
}

export const TipoERPTypes: Array<TipoERPInterface> = [
  { idTipoERP: TipoERPType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoERP: TipoERPType.MV, descricao: 'MV', idTipoConexao: TipoConexaoType.ORACLE },
  { idTipoERP: TipoERPType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo de Sistema de RH
export interface TipoRHInterface {
  idTipoRH: string
  descricao: string
  idTipoConexao: string
}

export enum TipoRHType {
  SEM_ACESSO = 'Sem Acesso',
  TOTVS = 'TOTVS',
  SPData = 'SPData'
}

export const TipoRHTypes: Array<TipoRHInterface> = [
  { idTipoRH: TipoRHType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoRH: TipoRHType.TOTVS, descricao: 'TOTVS', idTipoConexao: TipoConexaoType.SQLSERVER },
  { idTipoRH: TipoRHType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo de Sistema de OS
export interface TipoOSInterface {
  idTipoOS: string
  descricao: string
  idTipoConexao: string
}

export enum TipoOSType {
  SEM_ACESSO = 'Sem Acesso',
  MV = 'MV',
  SPData = 'SPData'
}

export const TipoOSTypes: Array<TipoOSInterface> = [
  { idTipoOS: TipoOSType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoOS: TipoOSType.MV, descricao: 'MV', idTipoConexao: TipoConexaoType.ORACLE },
  { idTipoOS: TipoOSType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo de Sistema de BI
export interface TipoBIInterface {
  idTipoBI: string
  descricao: string
  idTipoConexao: string
}

export enum TipoBIType {
  SEM_ACESSO = 'Sem Acesso',
  BI = 'ForHealth'
}

export const TipoBITypes: Array<TipoBIInterface> = [
  { idTipoBI: TipoBIType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoBI: TipoBIType.BI, descricao: 'For Health', idTipoConexao: TipoConexaoType.MYSQL }
]

// Tipo Notificacoes
export interface CanalNotificacaoTypesInterface {
  idCanal: string
  descricao: string
}

export enum CanalNotificacaoType {
  WHATSAPP = 'WA',
  EMAIL = 'EM',
  TELEFONE = 'FO'
}

export const CanalNotificacaoTypes: Array<CanalNotificacaoTypesInterface> = [
  { idCanal: CanalNotificacaoType.WHATSAPP, descricao: 'Whats APP' },
  { idCanal: CanalNotificacaoType.EMAIL, descricao: 'e-mail' },
  { idCanal: CanalNotificacaoType.TELEFONE, descricao: 'Fone' }
]

// Origem dos Dados
export interface OrigemDosDadosInterface {
  idOrigemDosDados: string
  descricao: string
}

export enum OrigemDosDadosType {
  ERP = 'ERP',
  RH = 'RH',
  OS = 'OS',
  BI = 'BI'
}

export const OrigemDosDadosTypes: Array<OrigemDosDadosInterface> = [
  { idOrigemDosDados: OrigemDosDadosType.ERP, descricao: 'ERP - Gestão' },
  { idOrigemDosDados: OrigemDosDadosType.RH, descricao: 'Recursos Humanos' },
  { idOrigemDosDados: OrigemDosDadosType.OS, descricao: 'Ordem de Serviços' },
  { idOrigemDosDados: OrigemDosDadosType.BI, descricao: 'Business Intelligence' }
]

// Grupos do DRG
export interface GrupoDRGInterface {
  idGrupoDRG: number
  descricao: string
}

export const GrupoDRGTypes: Array<GrupoDRGInterface> = [
  { idGrupoDRG: 1, descricao: 'Internação' },
  { idGrupoDRG: 2, descricao: 'Hospital' },
  { idGrupoDRG: 3, descricao: 'Beneficiário' },
  { idGrupoDRG: 4, descricao: 'Operadora' },
  { idGrupoDRG: 5, descricao: 'Médico' },
  { idGrupoDRG: 6, descricao: 'Cid Secundário' },
  { idGrupoDRG: 7, descricao: 'Procedimento' },
  { idGrupoDRG: 8, descricao: 'Médico Procedimento' },
  { idGrupoDRG: 9, descricao: 'CTI' },
  { idGrupoDRG: 10, descricao: 'RN' },
  { idGrupoDRG: 11, descricao: 'Condição Adquirida' },
  { idGrupoDRG: 12, descricao: 'Alta Administrativa' },
  { idGrupoDRG: 13, descricao: 'Análise Crítica' },
  { idGrupoDRG: 14, descricao: 'Suporte Ventilatório' },
  { idGrupoDRG: 15, descricao: 'Condição Adquirida Suporte Ventilatório' },
  { idGrupoDRG: 16, descricao: 'Sonda Vesical De Demora' },
  { idGrupoDRG: 17, descricao: 'Condição Adquirida Sonda Vesical De Demora' },
  { idGrupoDRG: 18, descricao: 'Cateter Vascular Central' },
  { idGrupoDRG: 19, descricao: 'Condição Adquirida Cateter Vascular Central' },
  { idGrupoDRG: 20, descricao: 'Dispositivo Terapêutico' },
  { idGrupoDRG: 21, descricao: 'Origem Recaída' },
  { idGrupoDRG: 22, descricao: 'Parto Adequado' },
  { idGrupoDRG: 23, descricao: 'Causa Externa Permanência' }
]

// Grupos do Fator RH
export interface GrupoFatorRHInterface {
  idGrupoFatorRH: number
  descricao: string
}
export const GrupoFatorRHTypes: Array<GrupoFatorRHInterface> = [
  { idGrupoFatorRH: 1, descricao: 'Dados Gerais' }
]

// export const VALIDACAO_MASCARA: RegExp = /^((\.[9]+)|([9]+(\.[9]+)?))$/

// export const VALIDACAO_NOME_VARAIVEL: RegExp = /^[A-Z_][0-9A-Z_]*$/

